import { render, staticRenderFns } from "./MdtModalDocumentUpload.vue?vue&type=template&id=5bec2f92&scoped=true"
import script from "./MdtModalDocumentUpload.vue?vue&type=script&lang=js"
export * from "./MdtModalDocumentUpload.vue?vue&type=script&lang=js"
import style0 from "./MdtModalDocumentUpload.vue?vue&type=style&index=0&id=5bec2f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec2f92",
  null
  
)

export default component.exports